import "./App.css";
import ScannerWrapper from "./components/ScannerWrapper";

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <h1>React barre code scanner</h1>
      </div>
      <ScannerWrapper />
    </div>
  );
}

export default App;
